type HapticKind = 'light' | 'medium' | 'success' | 'error';

const PATTERNS: Record<HapticKind, number | number[]> = {
  light: 25,
  medium: 50,
  success: [30, 60, 45],
  error: [70, 50, 70]
};

/* iOS no tiene `navigator.vibrate`. Lo único que hace vibrar al iPhone desde
   la web es el interruptor nativo de Safari 18 (`<input type="checkbox"
   switch>`): al cambiar de estado da un golpecito háptico, aunque esté oculto.
   Un golpe por toque, sin intensidad: los patrones se arman con golpes
   seguidos. El iPad no tiene motor de vibración, ahí no hace nada. */
const TICKS: Record<HapticKind, number> = { light: 1, medium: 1, success: 2, error: 3 };
const TICK_GAP_MS = 120;

function switchTick(): void {
  const label = document.createElement('label');
  label.ariaHidden = 'true';
  label.style.display = 'none';
  const input = document.createElement('input');
  input.type = 'checkbox';
  input.setAttribute('switch', '');
  label.appendChild(input);
  // Que el click sintético no le llegue a ningún listener de la app.
  label.addEventListener('click', (e) => e.stopPropagation());
  document.head.appendChild(label);
  label.click();
  label.remove();
}

export function haptic(kind: HapticKind = 'light') {
  if (typeof navigator === 'undefined') return;
  try {
    if ('vibrate' in navigator) {
      navigator.vibrate(PATTERNS[kind]);
      return;
    }
    if (typeof document === 'undefined') return;
    for (let i = 0; i < TICKS[kind]; i++) {
      if (i === 0) switchTick();
      else window.setTimeout(switchTick, i * TICK_GAP_MS);
    }
  } catch {
    /* ignore */
  }
}
